import React, { Component, Fragment } from 'react';
import { isEmpty } from 'lodash';

import  {
    Typography,
    Button,
    IconButton,
    FormControl,
    Select,
    OutlinedInput,
    FormHelperText,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    TextField
} from '@mui/material';

import Currency from '../../common/Currency';
import { MONTHS } from '../../../utils/generalFuncs';
import Creatable from '../../common/Creatable';
import InputText from '../../common/Form';
import { CloseRounded } from '@mui/icons-material';


class SalaryReceivePayment extends Component {
    state = { }
    
    handleChange = (e) => {
        const { name, value } = e.target;
        const regex = /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/

        if(name === "payment_amount"){
            if(regex.test(value) || value === ""){
                this.props.handleChange(name, parseFloat(value) , this.props.index)
            }
        } else {
            this.props.handleChange(name, value , this.props.index)
        }
    }
    handleChangeCreatable = (option) => {
        if(option){
            this.setState({                
                payment_salary_id: option.value,
                payment_salary_idDisplay: option
            })
        } else {
            this.setState({
                payment_salary_id: "",
                payment_salary_idDisplay: {label: "", value: ""}
            })

        }
    }
    deleteLine = (e) => {
        this.props.deleteLine(this.props.index)
    }

    render() {
        const { index, SALARIES, SALARY_CATS, EMPLOYEES, selected, salary, errors } = this.props;
        console.log("salary:", this.props.salary)
        let background = (index % 2 === 0) ? "" : "#f1f4f7";
       
        return (
            <div>
                <hr/>
                <div style={{background, padding: "15px", marginBottom: "15px" }}>
                    <h6>Dépense {index + 1}</h6>
                    {SALARY_CATS && EMPLOYEES && 
                    <Grid container spacing={2}>
                            <Grid item xs={1} >
                                <IconButton onClick={this.deleteLine}>
                                    <CloseRounded color="error" />
                                </IconButton>
                            </Grid>
                            <Grid item sm={7} xs={11}>
                                <Creatable
                                    required
                                    error={errors.payment_salary_id}
                                    label="Salaire"
                                    onChange={this.handleChangeCreatable}
                                    name="payment_salary_id" 
                                    id="payment_salary_id"
                                    options={Object.values(SALARIES).map( item => ({
                                            value: item.salary_id, 
                                            label: `${new Date(item.salary_date).toLocaleDateString("fr-FR") } | Salaire ${ MONTHS[new Date(item.salary_period_end).getMonth()]} ${new Date(item.salary_period_end).getFullYear() } - ${ item.salary_employee && 
                                                EMPLOYEES[item.salary_employee].employee_lastname
                                            } ${ item.salary_employee && 
                                                EMPLOYEES[item.salary_employee].employee_firstname
                                            } | ${item.salary_to_pay.toLocaleString("fr-FR")}`,
                                            disabled: selected.includes(item.salary_id)
                                        }
                                    ))}
                                    value={this.props.payment_salary_idDisplay || {value:"", label:""}}
                                />
                            </Grid>
                        <Grid item sm={4} xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="payment_amount"
                                error={errors.payment_amount}
                                value={this.props.payment_amount}
                                name="payment_amount"
                                label="Montant"
                                type="number"                              
                            />
                            {salary && 
                                <FormHelperText >Reste à Payer : {salary.salary_rest_to_pay}</FormHelperText>
                            }
                        </Grid>
                    </Grid>
                    }

                </div>                
            </div>
        );
    }
}


export default SalaryReceivePayment 